import { z } from "zod";
import { dateOnlySchema, versionSchema } from "./common.js";

const moneySchema = z.union([
  z.number().finite().nonnegative(),
  z.string().regex(/^\d{1,12}(?:\.\d{1,2})?$/),
]);

export const projectTimeAllocationCreateSchema = z
  .object({
    timesheetId: z.string().uuid(),
    projectId: z.string().uuid(),
    date: dateOnlySchema,
    minutes: z.number().int().min(1).max(1440),
    notes: z.string().trim().max(1000).optional(),
    hourlyCostRate: moneySchema.nullable().optional(),
  })
  .strict();
export type ProjectTimeAllocationCreateDto = z.infer<
  typeof projectTimeAllocationCreateSchema
>;

export const projectTimeAllocationUpdateSchema = z
  .object({
    version: versionSchema,
    date: dateOnlySchema.optional(),
    minutes: z.number().int().min(1).max(1440).optional(),
    notes: z.string().trim().max(1000).nullable().optional(),
    hourlyCostRate: moneySchema.nullable().optional(),
  })
  .strict();
export type ProjectTimeAllocationUpdateDto = z.infer<
  typeof projectTimeAllocationUpdateSchema
>;

export const projectTimeAllocationDeleteSchema = z
  .object({ version: versionSchema })
  .strict();
